export default __webpack_public_path__ + "static/media/data_setting_1.98058443.png";